import { SearchIcon } from "@heroicons/react/outline";
import DateRangePicker from "components/wps/DateRangePicker";
import { useEffect, useState } from "react";
import Select from 'react-select';
import './filterEvent.scss';

const FilterEvent = (props: any) => {
  const { translate, events, setEventID, setTShirtPage, setCategory, setAttendantPage, setEventType, setApplyDate, isMobile, suffix, setSuffix, setFilter, showPlatform, ticket_platform_option, setTicketPlatform, eventID } = props;
  const [eventDefault, setEventDefault] = useState(null as any);

  useEffect(() => {
    if (events?.length > 0) {
      if (eventID !== '') {
        events.forEach((item: any) => {
          if (item.value === eventID) {
            setEventDefault(item);
          }
        })
      } else {
        setEventDefault(events[0]);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventID, events]);


  const getEventsPlaceholder = () => {
    let placeholder = events[0].label;

    events.forEach((item: any) => {
      if (eventID && eventID !== '' && eventID === item.value) {
        placeholder = item.label;
      }
    });

    return placeholder;
  }

  return (
    <div className={`w-full p-[16px] bg-white gap-[12px] ${isMobile ? 'grid grid-cols-1' : 'rounded-[4px] flex items-center'}`} id="filter-event">
      {
        events.length > 0 &&
        <div className={`${isMobile ? "w-full" : "w-[calc(40%-6px)] max-w-[544px]"}`}>
          <div className="text-14 font-500 mb-[8px]">{translate('event-name')}</div>

          {
            eventDefault &&
            <Select
              styles={{
                input: (base) => ({
                  ...base,
                  "input:focus": {
                    boxShadow: "none",
                  },
                })
              }}
              defaultValue={eventDefault}
              name="event"
              options={events}
              className="text-14"
              classNamePrefix="select"
              placeholder={getEventsPlaceholder()}
              onChange={(e: any) => {
                setEventID(e.value);
                setTShirtPage(0);
                setCategory(null);
                setAttendantPage(1);
                setEventType(e.type);
              }} />
          }

        </div>
      }

      <div className={`${isMobile ? "w-full" : "w-[230px]"}`}>
        <div className="text-14 font-500 mb-[8px]">{translate('time')}</div>

        <DateRangePicker
          quickSelectDate={true}
          setApplyDate={setApplyDate}
          isMobile={isMobile}
          suffix={suffix}
          setSuffix={setSuffix}
          setFilter={setFilter}
        />
      </div>

      {
        showPlatform &&
        <div className={`${isMobile ? 'w-full' : "w-[200px]"}`}>
          <div className="text-14 font-500 mb-[8px]">{translate('ticket_platform')}</div>

          <Select
            styles={{
              input: (base) => ({
                ...base,
                "input:focus": {
                  boxShadow: "none",
                },
              })
            }}
            name="ticket_platform"
            options={ticket_platform_option}
            className="text-14"
            classNamePrefix="select"
            placeholder={ticket_platform_option[0].label}
            onChange={(e: any) => {
              setTicketPlatform(e.value);
            }} />

        </div>
      }

      <div className={`${!isMobile && "mt-[30px]"} h-[42px] rounded-[4px] px-[20px] border border-brand-500 flex items-center justify-center gap-x-[4px] cursor-pointer`} onClick={() => setFilter(true)}>
        <SearchIcon className="size-[20px] text-brand-500" strokeWidth={2} />

        <span className="text-14 text-brand-500">{translate('search')}</span>
      </div>
    </div>
  )
}

export default FilterEvent;